import PropTypes from 'prop-types';
import { Box, Alert, Text } from '@qga/roo-ui/components';
import TelLink from 'components/TelLink';
import { CUSTOMER_SUPPORT_HOTLINE_AU, CUSTOMER_SUPPORT_HOTLINE_INTL } from 'config/constants';

const BookingAlert = ({ children, icon = 'info', ...props }) => (
  <Box mb="7" data-testid={props['data-testid']} {...props}>
    <Alert variant="error" icon={{ name: icon }}>
      {children}
    </Alert>
    <Box px="4">
      <Text color="greys.steel">
        If you have any questions about your booking, please contact us on{' '}
        <TelLink number={CUSTOMER_SUPPORT_HOTLINE_AU} color="greys.steel" /> (Outside Australia:{' '}
        <TelLink number={CUSTOMER_SUPPORT_HOTLINE_INTL} color="greys.steel" />)
      </Text>
    </Box>
  </Box>
);

BookingAlert.propTypes = {
  children: PropTypes.node.isRequired,
  info: PropTypes.string,
};

export default BookingAlert;
